function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';

var SubscribeForm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SubscribeForm, _React$Component);

  function SubscribeForm() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SubscribeForm.prototype;

  _proto.render = function render() {
    return React.createElement("form", {
      name: "subscribeForm",
      method: "POST",
      netlifyHoneypot: "bot-field",
      "data-netlify": "true",
      id: "subscribe-form",
      className: "subscribe-form"
    }, React.createElement("div", {
      className: "screen-reader-text"
    }, React.createElement("label", null, "Don't fill this out if you're human: ", React.createElement("input", {
      name: "bot-field"
    }))), React.createElement("div", {
      className: "form-row"
    }, React.createElement("label", null, React.createElement("span", {
      className: "screen-reader-text"
    }, "Email address"), React.createElement("input", {
      className: "subscribe-email",
      type: "email",
      name: "email",
      placeholder: "Enter Email Address..."
    }))), React.createElement("input", {
      type: "hidden",
      name: "form-name",
      value: "subscribeForm"
    }), React.createElement("button", {
      className: "button",
      type: "submit"
    }, "Subscribe"));
  };

  return SubscribeForm;
}(React.Component);

export { SubscribeForm as default };